var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-overlay.ts
import { logger } from "@adornis/base/logging.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { ComponentSizeController } from "../../controllers/component-size-controller.js";
var XOverlay = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._extracted = false;
    this._size = new ComponentSizeController(this, { debounceTime: 200 });
    this.syncBackHeight = false;
  }
  styles() {
    return [{ ":host": { display: "block" } }];
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._overlay)
      document.body.removeChild(this._overlay);
  }
  connectedCallback() {
    super.connectedCallback();
    this._extracted = false;
  }
  render() {
    this._slotChange();
    return html`
      <slot ${ref((e) => this._slot = e)} @slotchange=${() => this._slotChange()}></slot>
    `;
  }
  _updateLoop() {
    requestAnimationFrame(() => {
      this._updateOverlayPosition();
      if (this.isConnected)
        this._updateLoop();
    });
  }
  _updateOverlayPosition() {
    if (!this._overlay)
      return;
    const rect = this.getBoundingClientRect();
    if (!rect.height)
      return;
    this._extracted = true;
    this._overlay.style.setProperty("position", "fixed");
    this._overlay.style.setProperty("top", "0");
    this._overlay.style.setProperty("transform", `translate(${rect.x}px, ${rect.y}px)`);
    this._overlay.style.setProperty("width", rect.width + "px");
    this._overlay.style.setProperty("height", rect.height + "px");
    this.style.setProperty("width", rect.width + "px");
    this.style.setProperty("height", rect.height + "px");
    if (this.syncBackHeight && this._overlay.scrollHeight > rect.height) {
      this._overlay.style.setProperty("height", this._overlay.scrollHeight + "px");
      this.style.setProperty("height", this._overlay.scrollHeight + "px");
    }
  }
  _slotChange() {
    if (!this._slot)
      return;
    const nodes = this._slot.assignedElements();
    if (nodes.length > 1)
      logger.warn(
        { xOverlay: this },
        "x-overlay has more than one slotted node, only the first Node will be used as the overlay!"
      );
    const overlay = nodes[0];
    if (!overlay || this._extracted)
      return;
    setTimeout(() => {
      if (!this.isConnected || this._extracted)
        return;
      this._overlay = overlay;
      this._updateOverlayPosition();
      this._updateLoop();
      document.body.appendChild(this._overlay);
    }, 10);
  }
};
__decorateClass([
  state()
], XOverlay.prototype, "_size", 2);
__decorateClass([
  property({ type: Boolean, attribute: "sync-back-height" })
], XOverlay.prototype, "syncBackHeight", 2);
XOverlay = __decorateClass([
  customElement("x-overlay")
], XOverlay);
export {
  XOverlay
};
